<template>
    <div class="form-default" v-if="formSetUp != null">
        <Form class="form_call" @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }" v-if="formVisible && !toManySendingMsg">
            <div class="form-in" :class="{'disabled-form' : formDisabled}">
               <TextInput
                    name="name"
                    type="text"
                    :placeholder="formSetUp.inputname"
                    class="form-group-flats"
                    :class="{'error' : errors.name}"
                />
                <TextInput
                    name="phone"
                    type="text"
                    :placeholder="formSetUp.inputphone"
                    v-maska="'+7 (###) ###-##-##'"
                    class="form-group-flats"
                    :class="{'error' : errors.phone}"
                />
                <div ref="turnstileContainer" v-show="turnstileVisible" style="margin: 8px 0;"></div>
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="submit" :disabled="errors.name || errors.phone">{{formSetUp.btn_name}}</button>
                </div>
            </div>
        </Form>
        <div class="successMessage" v-if="!formVisible && !toManySendingMsg">
            <h3>{{formSetUp.form_success_msg}}</h3>
        </div>
        <div class="to-many-requests-msg" v-if="toManySendingMsg">
            <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
            <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
            <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { Form } from "vee-validate";
    import * as Yup from "yup";
    import TextInput from "@/components/forms/TextInput.vue";
    import turnstileMixin, { TURNSTILE_SITE_KEY } from '@/mixins/turnstile';

    export default {
        name: 'FormFieldsFlatCard',
        mixins: [turnstileMixin],
        data () {
            return {
                globalLang: window.GlobalLang,
                toManySendingMsg: false,
                phone: '',
                name: '',
                formVisible: true,
                formDisabled: false,
                utmUrlParams: {},
            }
        },
        components: {
            TextInput,
            Form,
        },
        computed: mapGetters({
            formSetUp: 'loadFormSetUp',
        }),
        setup() {
            const schema = Yup.object().shape({
                name: Yup.string()
                    .required('Title is required')
                    .matches(/^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/),
                phone: Yup.string()
                    .required('First Name is required')
                    .matches(/^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/),
            });
            return { schema };
        },
        methods: {
            onSubmit(values) {
                this.name = values.name;
                this.phone = values.phone;

                let counter = parseInt(localStorage.getItem('Lumiere_submissionCounter') || '0');
                const lastTime = parseInt(localStorage.getItem('Lumiere_lastSubmissionTime') || '0');
                if (this.getCurrentMinutes() - lastTime >= 5) counter = 0;
                if (counter >= 5) {
                    this.toManySendingMsg = true;
                    return;
                }

                this.withTurnstile(() => this.sendData(counter));
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            sendData(counter) {
                const phone = this.normalizePhone(this.phone);
                if (!this.name || !phone) { this.resetTurnstile(); return; }

                const urlParams = new URLSearchParams(window.location.search);
                for (const [key, value] of urlParams.entries()) {
                    this.utmUrlParams[key] = value;
                }

                this.formDisabled = true;
                const dataForm = {
                    leadName: this.name,
                    phone: phone,
                    complex: 'Lumiere',
                    email: '',
                    advertisingChannel: "199",
                    advertisingChannelCode: "199",
                    advertisingChannelName: "Сайт жилого комплекса",
                    leadChannelCode: 'WEBSITE_REST_PRIVATE_OFFICE',
                    leadChannelName: "Личный кабинет",
                    requestWebsite: 'lumiere.bazis.kz',
                    description:
                        "Form on Flat" +
                        (this.utmUrlParams.utm_source   ? ` | Utm Source: ${this.utmUrlParams.utm_source}`     : '') +
                        (this.utmUrlParams.utm_medium   ? ` | Utm Medium: ${this.utmUrlParams.utm_medium}`     : '') +
                        (this.utmUrlParams.utm_campaign ? ` | Utm Campaign: ${this.utmUrlParams.utm_campaign}` : '') +
                        (this.utmUrlParams.utm_content  ? ` | Utm Content: ${this.utmUrlParams.utm_content}`   : '') +
                        (this.utmUrlParams.utm_term     ? ` | Utm Term: ${this.utmUrlParams.utm_term}`         : ''),
                    utmSource:   this.utmUrlParams.utm_source   || '',
                    utmMedium:   this.utmUrlParams.utm_medium   || '',
                    utmCampaign: this.utmUrlParams.utm_campaign || '',
                    utmName:     this.utmUrlParams.utm_source ? 'Сайт жилого комплекса - Lumiere' : 'UTM отсутствует - Lumiere',
                    utmContent:  this.utmUrlParams.utm_content  || '',
                    utmTerm:     this.utmUrlParams.utm_term     || '',
                    utmCode:     this.generateUniqueUTMCode(),
                    captcha:     this.turnstileToken,
                    captchaKey:  TURNSTILE_SITE_KEY,
                };

                this.$store.dispatch('sendFormDataToCRM', dataForm).then((response) => {
                    if (response && response.status === 200) {
                        this.formVisible = false;
                        counter++;
                        localStorage.setItem('Lumiere_submissionCounter', String(counter));
                        localStorage.setItem('Lumiere_lastSubmissionTime', String(this.getCurrentMinutes()));
                        window.dataLayer.push({ event: 'form_sent' });
                    } else {
                        this.formDisabled = false;
                        this.resetTurnstile();
                        if (response && response.response && response.response.status === 429) {
                            this.toManySendingMsg = true;
                        } else {
                            console.warn('Ошибка при отправке формы - обратитесь в Call Center');
                        }
                    }
                });
            },
            normalizePhone(phone) {
                const digits = (phone || '').replace(/\D/g, '');
                if (digits.length !== 11 || !digits.startsWith('7')) return null;
                return `+7 ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9, 11)}`;
            },
            generateUniqueUTMCode() {
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
                const array = new Uint8Array(10);
                crypto.getRandomValues(array);
                return Array.from(array, b => chars[b % chars.length]).join('');
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-flat.scss';
    @import '@/styles/components/forms/form-fields-flat.scss';
</style>